const EDIT_APP_PUSH_DRAFT_PREFIX = 'admin:appPushDraft:edit:'
export const NEW_APP_PUSH_DRAFT_KEY = 'admin:appPushDraft:new'

const APP_PUSH_PARAM_FIELDS = [
    'meetId',
    'coupangId',
    'content',
    'isReserve',
    'pushType',
    'cCode',
    'deviceType',
    'reserveHour',
    'reserveMinute',
    'startTime',
    'endTime',
]

export const APP_PUSH_WEEK_OPTIONS = [
    { id: 1, name: '월' },
    { id: 2, name: '화' },
    { id: 3, name: '수' },
    { id: 4, name: '목' },
    { id: 5, name: '금' },
    { id: 6, name: '토' },
    { id: 7, name: '일' },
]

export const createDefaultAppPushParams = () => ({
    meetId: null,
    coupangId: null,
    content: '',
    isReserve: 0,
    pushType: 1,
    cCode: 'kr',
    deviceType: 0,
    timeType: null,
    reserveHour: '',
    reserveMinute: '',
    weekType: '',
    startTime: new Date(),
    endTime: new Date(),
})

// App 푸시 등록/수정 화면에서 필드 전환 규칙을 한 곳에서 맞춘다.
export const applyAppPushParamFieldChange = ({
    params = {},
    name,
    value,
    pushTypeExtraResets = {},
}) => {
    if (name === 'isReserve' || name === 'deviceType') {
        return {
            ...params,
            [name]: Number(value),
        }
    }

    if (name === 'pushType') {
        const nextPushType = Number(value)
        const nextParams = {
            ...params,
            pushType: nextPushType,
        }

        if (nextPushType === 2 || nextPushType === 4) {
            return {
                ...nextParams,
                coupangId: null,
                ...(pushTypeExtraResets[nextPushType] || {}),
            }
        }

        if (nextPushType === 3) {
            return {
                ...nextParams,
                meetId: null,
                ...(pushTypeExtraResets[nextPushType] || {}),
            }
        }

        return {
            ...nextParams,
            meetId: null,
            coupangId: null,
            ...(pushTypeExtraResets[nextPushType] || {}),
        }
    }

    if (name === 'cCode') {
        return {
            ...params,
            meetId: null,
            pushType: 1,
            [name]: value,
        }
    }

    return {
        ...params,
        [name]: value,
    }
}

// 저장 직전 검증 문구를 한 기준으로 맞춰 등록/수정 화면 차이를 없앤다.
export const getAppPushSubmitErrorMessage = ({
    params = {},
    checked = [],
}) => {
    if ((Number(params.pushType) === 2 && !params.meetId) || (Number(params.pushType) === 3 && !params.coupangId) || (Number(params.pushType) === 4 && !params.meetId)) {
        return '상품을 선택하세요'
    }

    if (!params.content) {
        return '내용을 등록해주세요'
    }

    if (params.isReserve && checked.length === 0) {
        return '요일을 등록해주세요'
    }

    if (params.isReserve && (params.reserveHour === '' || params.reserveMinute === '')) {
        return '시간을 등록해주세요'
    }

    if (params.isReserve && (!params.startTime || !params.endTime)) {
        return '일자를 등록해주세요'
    }

    return ''
}

// 서버 전송용 payload를 한 곳에서 만들어 필드 누락 없이 유지한다.
export const createAppPushSubmitFormData = ({
    params = {},
    checked = [],
    pushHistoryId,
    getLegacyTimeTypeFromReserveTime,
}) => {
    const formData = new FormData()

    if (pushHistoryId !== undefined) {
        formData.append('pushHistoryId', pushHistoryId)
    }

    formData.append('meetId', params.meetId)
    formData.append('coupangId', params.coupangId)
    formData.append('content', params.content)
    formData.append('isReserve', params.isReserve)
    formData.append('pushType', params.pushType)
    formData.append('cCode', params.cCode)
    formData.append('deviceType', params.deviceType)
    formData.append('timeType', params.isReserve ? (getLegacyTimeTypeFromReserveTime(params.reserveHour, params.reserveMinute) || '') : '')
    formData.append('reserveHour', params.isReserve ? params.reserveHour : '')
    formData.append('reserveMinute', params.isReserve ? params.reserveMinute : '')
    formData.append('startTime', params.startTime)
    formData.append('endTime', params.endTime)
    formData.append(
        'weekType',
        [...checked]
            .map(Number)
            .filter((value) => !Number.isNaN(value))
            .sort((a, b) => a - b),
    )

    return formData
}

// 대상 선택값 반영 규칙을 재사용해 등록/수정 화면의 setter 코드를 줄인다.
export const applyAppPushTargetSelection = ({
    params = {},
    field,
    value,
}) => ({
    ...params,
    [field]: value,
})

// 요일 체크박스 선택 순서를 유지하면서 add/remove만 처리한다.
export const toggleAppPushWeekType = ({
    checked = [],
    value,
    isChecked,
}) => {
    const nextValue = Number(value)
    const normalizedChecked = [...checked]
        .map(Number)
        .filter((item) => !Number.isNaN(item))

    if (Number.isNaN(nextValue)) {
        return normalizedChecked
    }

    if (isChecked) {
        return normalizedChecked.includes(nextValue)
            ? normalizedChecked
            : [...normalizedChecked, nextValue]
    }

    return normalizedChecked.filter((item) => item !== nextValue)
}

// 같은 검색어로 첫 페이지를 보고 있으면 즉시 재조회하고, 아니면 조건만 갱신한다.
export const getAppPushCoupangSearchState = ({
    currentPage = 1,
    searchQuery = '',
    searchText = '',
}) => ({
    shouldFetchCurrentPage: currentPage === 1 && searchQuery === searchText,
    shouldResetPage: currentPage !== 1,
    nextSearchQuery: searchText,
})

// 목록 API 응답 규칙을 공통화해 등록/수정 화면의 분기 차이를 줄인다.
export const fetchAppPushListData = async ({
    request,
    payload,
    setTotalCount,
    setRows,
    onForbidden,
    onError,
    fallbackErrorMessage,
}) => {
    try {
        const { data } = await request(payload)

        if (data.code === 200) {
            setTotalCount(data.data?.count ?? 0)
            setRows(data.data?.rows ?? [])
            return
        }

        if (data.code === 403) {
            onForbidden?.()
            return
        }

        onError?.(data.message)
    } catch (_error) {
        onError?.(fallbackErrorMessage)
    }
}

const getSessionStorage = () => {
    if (typeof window === 'undefined') {
        return null
    }

    return window.sessionStorage
}

const serializeDateValue = (value) => {
    if (value === null) {
        return null
    }

    if (value === undefined || value === '') {
        return ''
    }

    const nextDate = new Date(value)

    return Number.isNaN(nextDate.getTime()) ? '' : nextDate.toISOString()
}

const parseDateValue = (value, fallbackValue) => {
    if (value === null) {
        return null
    }

    if (value === undefined || value === '') {
        return fallbackValue
    }

    const nextDate = new Date(value)

    return Number.isNaN(nextDate.getTime()) ? fallbackValue : nextDate
}

const parseNumberValue = (value, fallbackValue) => {
    if (value === undefined || value === null || value === '') {
        return fallbackValue
    }

    const parsedValue = Number(value)

    return Number.isNaN(parsedValue) ? fallbackValue : parsedValue
}

// App 푸시 폼에서 다시 입력 비용이 큰 값만 sessionStorage에 남긴다.
export const createAppPushDraftPayload = ({
    params = {},
    checked = [],
    curPage = 1,
    meetWeCurPage = 1,
    coupangCurPage = 1,
    searchText = '',
    searchQuery = '',
}) => {
    return {
        params: {
            meetId: params.meetId ?? null,
            coupangId: params.coupangId ?? null,
            content: params.content || '',
            isReserve: params.isReserve ?? 0,
            pushType: params.pushType ?? 1,
            cCode: params.cCode || 'kr',
            deviceType: params.deviceType ?? 0,
            reserveHour: params.reserveHour ?? '',
            reserveMinute: params.reserveMinute ?? '',
            startTime: serializeDateValue(params.startTime),
            endTime: serializeDateValue(params.endTime),
        },
        checked: [...checked].map(Number).sort((a, b) => a - b),
        curPage,
        meetWeCurPage,
        coupangCurPage,
        searchText: searchText || '',
        searchQuery: searchQuery || '',
    }
}

// 서버 기본값 위에 draft만 덮어써서 새로고침 뒤에도 작성 흐름을 이어간다.
export const applyAppPushDraft = ({
    baseParams = {},
    baseChecked = [],
    baseCurPage = 1,
    baseMeetWeCurPage = 1,
    baseCoupangCurPage = 1,
    baseSearchText = '',
    baseSearchQuery = '',
    draft,
}) => {
    if (!draft) {
        return {
            params: baseParams,
            checked: baseChecked,
            curPage: baseCurPage,
            meetWeCurPage: baseMeetWeCurPage,
            coupangCurPage: baseCoupangCurPage,
            searchText: baseSearchText,
            searchQuery: baseSearchQuery,
        }
    }

    const draftParams = draft.params || {}
    const nextParams = {
        ...baseParams,
    }

    APP_PUSH_PARAM_FIELDS.forEach((field) => {
        if (draftParams[field] === undefined) {
            return
        }

        if (field === 'startTime' || field === 'endTime') {
            nextParams[field] = parseDateValue(draftParams[field], baseParams[field] ?? null)
            return
        }

        nextParams[field] = draftParams[field]
    })

    return {
        params: nextParams,
        checked: Array.isArray(draft.checked) ? draft.checked.map(Number).filter((value) => !Number.isNaN(value)).sort((a, b) => a - b) : baseChecked,
        curPage: parseNumberValue(draft.curPage, baseCurPage),
        meetWeCurPage: parseNumberValue(draft.meetWeCurPage, baseMeetWeCurPage),
        coupangCurPage: parseNumberValue(draft.coupangCurPage, baseCoupangCurPage),
        searchText: draft.searchText ?? baseSearchText,
        searchQuery: draft.searchQuery ?? baseSearchQuery,
    }
}

export const createEditAppPushDraftKey = (pushHistoryId) => `${EDIT_APP_PUSH_DRAFT_PREFIX}${pushHistoryId}`

export const readAppPushDraft = (draftKey) => {
    const storage = getSessionStorage()

    if (!storage || !draftKey) {
        return null
    }

    try {
        const storedValue = storage.getItem(draftKey)
        return storedValue ? JSON.parse(storedValue) : null
    } catch (_error) {
        return null
    }
}

export const saveAppPushDraft = (draftKey, draftValue) => {
    const storage = getSessionStorage()

    if (!storage || !draftKey) {
        return
    }

    try {
        storage.setItem(draftKey, JSON.stringify(draftValue))
    } catch (_error) {
        // sessionStorage가 막혀 있어도 작성 흐름은 그대로 유지한다.
    }
}

export const clearAppPushDraft = (draftKey) => {
    const storage = getSessionStorage()

    if (!storage || !draftKey) {
        return
    }

    try {
        storage.removeItem(draftKey)
    } catch (_error) {
        // storage 정리에 실패해도 화면 동작은 계속 진행한다.
    }
}
